import { createFileRoute, redirect } from '@tanstack/react-router'
import { DeviceForm } from '../../features/devices/DeviceForm.tsx'

export const Route = createFileRoute('/_app/devices/add')({
	component: RouteComponent,
	beforeLoad: ({ context: { sub, isAdmin, impersonation } }) => {
		const canManageDevices = sub.features.includes('manage-devices')
		if (!isAdmin || (!impersonation && !canManageDevices)) {
			throw redirect({ to: '/devices' })
		}
	},
})

function RouteComponent() {
	return <DeviceForm />
}
